import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  PinVerificationType,
  usePinVerification,
} from "./pin-verification-context";

export const MergePackingSlipConfirmationModal = memo(
  function MergePackingSlipConfirmationModal({
    onConfirm,
    onCancel,
    open,
  }: {
    onConfirm: () => void;
    onCancel: () => void;
    open: boolean;
  }) {
    const { executeWithPinCheck } = usePinVerification();

    const handleConfirm = () => {
      executeWithPinCheck(
        () => {
          onConfirm();
        },
        { type: PinVerificationType.MergeAfterPackingSlipPrinted },
      );
    };

    return (
      <RedoModal
        isOpen={open}
        onModalCloseRequested={onCancel}
        primaryButton={{ text: "Continue", onClick: handleConfirm }}
        secondaryButton={{ text: "Cancel", onClick: onCancel }}
        title="Packing slip already printed"
      >
        <Text>
          At least one of these fulfillments already has a packing slip printed.
          Are you sure you want to merge them?
        </Text>
      </RedoModal>
    );
  },
);
